import { useTranslation } from '@rhino-project/core/i18n';
import { Typography } from '@heroui/react';
import { BaseAuthedPage, MaxWidth } from '@rhino-project/ui-heroui';
import RecruitingProjection from '../components/recruiting/RecruitingProjection';

const RecruitingProjectionPage = () => {
  const { t } = useTranslation();

  return (
    <BaseAuthedPage>
      <MaxWidth>
        <Typography.Heading level={1} className="mb-6">
          {t('frontend.messages.roster_projection')}
        </Typography.Heading>
        <RecruitingProjection />
      </MaxWidth>
    </BaseAuthedPage>
  );
};

export default RecruitingProjectionPage;
